import { Col, Container, Row } from "react-bootstrap";

import GaugePart from "./GaugePart";

interface GaugeProps {
  mode: "DPE" | "GES";
  value?: string;
  mini?: boolean;
}

const Gauge = (props: GaugeProps) => {
  const colorMe = (letter?: string) => {
    switch (letter) {
      case "A":
        if (props.mode === "DPE") {
          return "#009D69";
        } else {
          return "#99D6FC";
        }
      case "B":
        if (props.mode === "DPE") {
          return "#00B34A";
        } else {
          return "#7FACCC";
        }
      case "C":
        if (props.mode === "DPE") {
          return "#41BD70";
        } else {
          return "#6B87A8";
        }
      case "D":
        if (props.mode === "DPE") {
          return "#FDE800";
        } else {
          return "#536582";
        }
      case "E":
        if (props.mode === "DPE") {
          return "#FFB400";
        } else {
          return "#444867";
        }
      case "F":
        if (props.mode === "DPE") {
          return "#FF7D29";
        } else {
          return "#322F46";
        }
      case "G":
        if (props.mode === "DPE") {
          return "#E90117";
        } else {
          return "#251A2F";
        }
      default:
        return "#FFFFFF";
    }
  };

  const colorMyFont = () => {
    return "#FFFFFF";
  };
  const renderGaugePart = (value?: string, letter?: GaugeProps["value"]) => {
    if (value === letter) {
      return (
        <GaugePart
          shape="selected"
          color={colorMe(letter)}
          letter={letter}
          fontColor={colorMyFont()}
        />
      );
    }
    switch (letter) {
      case "A":
        return <GaugePart shape="start" color={colorMe(letter)} />;
      case "G":
        return <GaugePart shape="end" color={colorMe(letter)} />;
      default:
        return <GaugePart shape="middle" color={colorMe(letter)} />;
    }
  };

  return props.value ? (
    <Container className="p-1">
      <Row className="h-100 w-50">
        <Col className="p-0 me-1">{renderGaugePart(props.value, "A")}</Col>
        <Col className="p-0 me-1">{renderGaugePart(props.value, "B")}</Col>
        <Col className="p-0 me-1">{renderGaugePart(props.value, "C")}</Col>
        <Col className="p-0 me-1">{renderGaugePart(props.value, "D")}</Col>
        <Col className="p-0 me-1">{renderGaugePart(props.value, "E")}</Col>
        <Col className="p-0 me-1">{renderGaugePart(props.value, "F")}</Col>
        <Col className="p-0">{renderGaugePart(props.value, "G")}</Col>
      </Row>
    </Container>
  ) : (
    <span className={"dwelling_infos_subtitle fst-italic"}>Non mesuré</span>
  );
};

export default Gauge;
